module.exports = __webpack_public_path__ + "static/img/thumb_14.0233d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_14.png
// module id = 7MGy
// module chunks = 0